export default __webpack_public_path__ + "static/media/siderobo.1d8dcf22.svg";